var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 9c-2.215 0-4.361.295-6.58.295-1.087 0-2.254.002-3.29.191-.52.095-1.093-.068-1.616.027-.608.111-1.293.273-1.915.273-1.055 0-2.146.099-3.17.099-3.966 0-7.46-.59-11.429-.59M1.5 16.081c6.01 0 11.987-.196 17.997-.196 1.404 0 2.764.098 4.167.098h2.96c.343 0 .628.197.973.197H29.5M1.5 22.278c2.343 0 4.599-.003 6.913.273.787.094 1.564.12 2.36.12 2.66 0 5.33-.098 8.003-.098 2.158 0 4.24-.393 6.388-.393 1.458 0 2.886.062 4.336.062",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
};

export default SvgHamburger;